import React, { useState, useEffect } from 'react';
import { AddToWishlistContext } from './AddToWishlistContext';
import { getStoreId, getProductPricePrefixAsync, getProductButtonColorsAsync, getProductButtonFields } from '../../../utils/StoreConfigManager';

const storeId = getStoreId();
const ADD_TO_WISHLIST_COOKIE_ENUM = 'wishList';

// TODO: Add backend cart saving support, possibly by storing UUIDs + cookies
// Add To Cart Context provides modal context with access to add/remove cart functionality
// Context also used in top level UI to create a dropdown add to cart menu
const AddToWishlistContextComponent = (props) => {
    const [wishList, setWishList] = useState([]);
    const [itemCount, setItemCount] = useState(0);
    const [pricePrefix, setPricePrefix] = useState('$');
    const [colors, setColors] = useState();

    // TODO: Currently not tied to any functionality. To be used in dropdown cart
    // Load saved cookie if ID stored in cookie matches ID of current store
    useEffect(() => {
        (async () => {
            setPricePrefix(await getProductPricePrefixAsync());
            setColors(await getProductButtonColorsAsync());
        })()
        const wishListCookie = JSON.parse(getCookie(ADD_TO_WISHLIST_COOKIE_ENUM));
        if (wishListCookie && wishListCookie['id'] === storeId) {
            const savedList = wishListCookie['wishList'];
            setWishList(savedList);
        }
    }, [])
    // Saves add to cart list in a cookie
    useEffect(() => {
        if (wishList.length > -1) {
            setWishlistCookie();
        }
        setItemCount(wishList.length);
    }, [wishList])

    const setWishlistCookie = () => {
        const today = new Date();
        const tomorrow = new Date(today);

        const cookieObject = {
            id: storeId,
            wishList: wishList
        }
        const cookieString = `wishList=${JSON.stringify(cookieObject)}; expires=${tomorrow.getDate() + 1}`;
        // Sets cookie to expire a day later from latest update
        document.cookie = cookieString;
    }

    const getCookie = (name) => {
        const regEx = new RegExp(name + "=([^;]+)");
        const value = regEx.exec(document.cookie);
        return value ? unescape(value[1]) : null;
    }

    const addToWishlist = (item) => {
        setWishList([...wishList, item]);
    }

    const removeFromWishlist = (itemSKU) => {
        const removedList = wishList.filter(item => item.SKU !== itemSKU);
        setWishList(removedList);
    }

    const contextValue = {
        wishList,
        itemCount,
        addToWishlist,
        removeFromWishlist,
        pricePrefix,
        colors,
    }

    return (
        <AddToWishlistContext.Provider value={contextValue}>
            {props.children}
        </AddToWishlistContext.Provider>
    )
}

export default AddToWishlistContextComponent;